var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 101,
    viewBox: "0 0 100 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33_178)"
  }, /*#__PURE__*/React.createElement("path", {
    id: 1,
    d: "M33.5098 35.346L41.7672 50.6776L42.9667 48.5745L38.001 27.5684L33.5098 35.346Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0206 58.9907L37.504 58.1448L26.8621 46.8535L24.997 50.0822L24.3657 51.1752L37.0206 58.9907Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1928 55.1883L39.8638 54.0105L31.5955 38.6572L28.5635 43.9097L39.1928 55.1883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3296 44.4313L49.9994 36.2442L61.7236 56.8066H78.8751L74.9935 50.0841L49.994 6.78223L40.3657 23.4594L45.3296 44.4313Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7071 71.8126L30.921 69.6824L13.8127 69.4551L9.87158 76.2803L29.7071 71.8126Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7615 60.0596H63.5883L74.5603 79.2926H25.4397L27.5229 75.6419L7.65858 80.1187L0 93.3851H100L80.7615 60.0596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9015 62.709L35.4083 61.8216L22.739 53.9971L20.248 58.3134L34.9015 62.709Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7647 66.4542L33.2463 65.6101L18.5749 61.209L15.6763 66.2287L32.7647 66.4542Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33_178"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 86.6038,
    fill: "white",
    transform: "translate(0 6.78223)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo_white.8b7c832b1518815d9e9815a92c1cae99.svg";
export { ForwardRef as ReactComponent };